/**
 * Delete Confirmation Modal for Expense Invoices
 * Material-UI Dialog replacing window.confirm
 */

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface DeleteConfirmationModalProps {
  open: boolean;
  documentReference?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting?: boolean;
}

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  open,
  documentReference,
  onConfirm,
  onCancel,
  isDeleting = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={isDeleting ? undefined : onCancel}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="delete-dialog-title" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningAmberIcon color="error" />
        Usuń dokument kosztowy
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-description">
          Czy na pewno chcesz usunąć dokument{' '}
          {documentReference && (
            <>
              <strong>{documentReference}</strong>
            </>
          )}
          ?
          <br />
          <br />
          Ta operacja jest <strong>nieodwracalna</strong> i usunie wszystkie powiązane dane.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isDeleting} color="inherit">
          Anuluj
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isDeleting}
          color="error"
          variant="contained"
          autoFocus
        >
          {isDeleting ? 'Usuwanie...' : 'Usuń'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
